import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import IndexManagementPage from './IndexManagementPage';

type TParams = { id: string, url: string }

function IndexManagement({ match }: RouteComponentProps<TParams>) {
    return (
      <Switch>
        <Route exact path={`${match.url}`} component={IndexManagementPage} />
      </Switch>
    );
}

export default IndexManagement;
